import SectionStudyArea from "./section_study";

function RightViewArea(props: any) {
  let myProps = {
    textbook_info: {},
    ...props
  };
  let default_textbook_info = {
    a_seq: "",
    a_title: "",
    a_subject: "",
    section_arr: [],
    study_arr: [],
  };
  let textbook_info = {
    ...default_textbook_info,
    ...myProps.textbook_info
  };

  return (
    <div>
      {textbook_info.a_title}
      <SectionStudyArea
        section_arr={textbook_info.section_arr}
        study_arr={textbook_info.study_arr}
      ></SectionStudyArea>
    </div>
  );
};
export default RightViewArea;